import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/giftCard-statistic`;

const trend = (merchantId, filters) => {
	return Client.get(`${baseUrl}/${merchantId}/transactions/date-type-group`, {
		...filters,
	});
};

const summary = (merchantId, filters) => {
	return Client.get(`${baseUrl}/${merchantId}/transactions/date/statistic`, {
		...filters,
	});
};

const redemptionSummary = (merchantId, branchId, filters, groupType) => {
	return Client.get(`${baseUrl}/${merchantId}/redemption/group/info`, {
		branchId,
		...filters,
		groupType,
	});
};

const redemptionBreakdown = (merchantId, branchId, filters, page, pageSize) => {
	return Client.get(`${baseUrl}/${merchantId}/redemption/list`, {
		branchId,
		...filters,
		page,
		pageSize,
	});
};

const redemptionSummaryExport = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/redemption/export/group/info`,
		{
			...data,
		},
		{
			responseType: 'blob',
		}
	);
};

const redemptionBreakdownExport = (merchantId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/redemption/export/list`,
		{
			...data,
		},
		{
			responseType: 'blob',
		}
	);
};

const paymentECardList = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/sell/list`, {
		...data,
	});
};

const paymentECardSummary = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/sell/summary`, {
		...data,
	});
};

export default {
	trend,
	summary,
	redemptionSummary,
	redemptionBreakdown,
	redemptionSummaryExport,
	redemptionBreakdownExport,
	paymentECardList,
	paymentECardSummary,
};
